import { formatDate, formatCurrency, revenue } from "./jobConstants";
import { jobStatus } from "@/utils/szStatus";

const JobsMobileCards = ({ jobs, onViewDetails }) => (
  <div className="md:hidden flex flex-col gap-[11px] mt-4">
    {jobs.map((job) => {
      const st = jobStatus(job.status);
      const isAdvanced = (job.crew_count > 1) || (job.crew_members?.length > 1);
      return (
        <div
          key={job.id}
          className="bg-white rounded-[14px] p-[14px]"
          style={{ border: "1px solid #E6E9EF", borderLeft: `4px solid ${st.fg}` }}
        >
          <div className="flex items-start justify-between gap-2.5">
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <button onClick={() => onViewDetails(job)} className="text-sm font-semibold text-left truncate">{job.title}</button>
                {isAdvanced && (
                  <span className="text-[9px] font-bold px-1.5 py-0.5 rounded-[5px] shrink-0" style={{ fontFamily: "Poppins", color: "#78287C", background: "#EDE4F4" }}>ADV</span>
                )}
              </div>
              <div className="text-[11.5px] text-[#8A90A2] sz-mono">JOB-{job.id?.substring(0, 6).toUpperCase()}</div>
            </div>
            <span className="sz-badge sz-nodot shrink-0" style={{ color: st.fg, background: st.bg }}>{st.label}</span>
          </div>

          <div className="mt-2.5 text-[12.5px] text-[#2B3142]">
            {(job.owner?.name || job.client_name || "—")} · {job.location?.split(",")[0] || "—"} · {formatDate(job.date)}
          </div>

          <div className="flex items-center justify-between mt-3">
            <div className="text-xs text-[#8A90A2]">
              Budget <strong className="text-[#0C1120]" style={{ fontFamily: "Poppins" }}>{formatCurrency(job.budget || job.total_amount)}</strong>
              {" · "}Rev <strong className="text-[#15803D]" style={{ fontFamily: "Poppins" }}>{formatCurrency(revenue(job))}</strong>
            </div>
            <button onClick={() => onViewDetails(job)} className="px-3.5 py-[7px] rounded-[9px] bg-white text-xs font-semibold text-[#2B3142]" style={{ border: "1px solid #E0E3EB" }}>View</button>
          </div>
        </div>
      );
    })}
  </div>
);

export default JobsMobileCards;
